import Stats from 'stats.js'
import Stage from './Stage'
import Manager from './Manager'

export default class Canvas {
  constructor (options = {}) {
    const { elem = 'body' } = options

    this.stage = new Stage(elem)
    this.manager = new Manager(this.stage)

    if (process.env.NODE_ENV !== 'production') {
      this.stats = new Stats()
      document.body.appendChild(this.stats.dom)
    }
  }

  render () {
    this.stage.update()
    this.manager.update()
    this.stats && this.stats.update()
    requestAnimationFrame(() => this.render())
  }
}
